import React, {useState} from 'react';
import {Button, InputGroup, Modal, Alert} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import {observer} from "mobx-react-lite";
import {IMaskInput} from "react-imask";
import {YMInitializer} from 'react-yandex-metrika';
import ym from "react-yandex-metrika";

const FormSelection = observer(({show, onHide}) => {

    const PhoneMask = "+0 (000) 000-00-00";

    const [name, setName] = useState('')
    const [phone, setPhone] = useState('')
    const [firstDate, setFirstDate] = useState('')
    const [lastDate, setLastDate] = useState('')

    const [formState, setFormState] = useState(0);
    const [alertMessage, setAlertMessage] = useState('');

    const resetFormAndAlert = () => {
        setName('');
        setPhone('');
        setFirstDate('');
        setLastDate('');
        setFormState(0);
        setAlertMessage('');
    };

    const handleClose = () => {
        resetFormAndAlert();
        onHide();
    }

    const sendForm = async () => {
        setAlertMessage('');

        if (!name.trim()){
            setAlertMessage('Пожалуйста, введите Ваше имя.');
            return;
        }

        if (!phone || phone.length !== 18){
            setAlertMessage('Пожалуйста, введите корректный номер телефона.');
            return;
        }

        if (!firstDate){
            setAlertMessage('Пожалуйста, выберите дату заезда.');
            return;
        }

        if (!lastDate || new Date(lastDate) < new Date(firstDate)){
            setAlertMessage('Пожалуйста, выберите корректную дату выезда (не раньше даты заезда).');
            return;
        }

        const formData = {
            name: name.trim(),
            phone: phone,
            firstDate: firstDate,
            lastDate: lastDate
        };

        try {
            const response = await fetch('/send-booking-email', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                const result = await response.json();

                if (result.success) {
                    console.log('Заявка успешно отправлена:', result.message);
                    setFormState(1);
                    ym('reachGoal','Заявка Родник')
                } else {
                    console.error('Ошибка при отправке заявки (сервер):', result.message);
                    setAlertMessage(result.message || 'Произошла ошибка при отправке заявки.');
                    setFormState(0);
                }
            } else {
                const errorBody = await response.text();
                console.error('Ошибка при отправке заявки (статус):', response.status, errorBody);
                setAlertMessage(`Ошибка сервера: ${response.status} ${response.statusText}`);
                setFormState(0);
            }

        } catch (error) {
            console.error('Непредвиденная ошибка fetch:', error);
            setAlertMessage('Произошла ошибка при отправке заявки. Проверьте ваше интернет-соединение.');
            setFormState(0);
        }
    };

    return (
        <>
            <YMInitializer accounts={[101931374]} />
            <Modal
                show = {show}
                onHide = {handleClose}
                size="md"
                centered
            >
                {alertMessage && formState !== 1 && (
                    <Alert variant="danger" onClose={() => setAlertMessage('')} dismissible>
                        {alertMessage}
                    </Alert>
                )}

                {formState === 1 ? (
                    <>
                        <Modal.Header closeButton>
                            <Modal.Title>Бронирование путёвки Online</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <h5>Ваша заявка успешно отправлена! Мы свяжемся с Вами в ближайшее время. </h5>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                variant="secondary"
                                onClick={handleClose}
                            >
                                Закрыть
                            </Button>
                        </Modal.Footer>
                    </>
                ) : (
                    <>
                        <Modal.Header closeButton>
                            <Modal.Title>Бронирование путёвки Online</Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="mb-0">
                            <Form.Control
                                className="mb-3"
                                placeholder="Ваше имя"
                                onChange={e => setName(e.target.value)}
                                value={name}
                                required
                            />
                            <div className="form-group mb-3">
                                <IMaskInput
                                    mask={PhoneMask}
                                    value={phone}
                                    placeholder="Ваш телефон (обязательно)"
                                    onChange={(event) => {
                                        setPhone(event.target.value);
                                    }}
                                    className="form-control"
                                    type="tel"
                                    required
                                />
                                <Form.Text className="text-muted">
                                    Вводите номер в формате +7 (ХХХ) ХХХ-ХХ-ХХ
                                </Form.Text>
                            </div>
                            <InputGroup className="mb-1 d-flex flex-column">
                                <InputGroup.Text className="mb-2 w-100">Дата заезда и выезда
                                    (обязательно)</InputGroup.Text>
                                <div className="w-100 d-flex flex-row">
                                    <Form.Control
                                        type="date"
                                        className="me-2"
                                        onChange={e => setFirstDate(e.target.value)}
                                        value={firstDate}
                                        required
                                    />
                                    <Form.Control
                                        type="date"
                                        min={firstDate || ""}
                                        onChange={e => setLastDate(e.target.value)}
                                        value={lastDate}
                                        required
                                    />
                                </div>
                            </InputGroup>
                            <div
                                className="text-muted text-left w-100 small"
                                style={{
                                    fontSize: '12px',
                                    fontStyle: 'italic'
                                }}
                            >
                                Нажимая кнопку "Отправить заявку", вы принимаете условия политики конфиденциальности.
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                variant={"secondary"}
                                onClick={handleClose}
                            >
                                Закрыть
                            </Button>
                            <Button
                                variant={"success"}
                                onClick={sendForm}
                            >
                                Отправить заявку
                            </Button>
                        </Modal.Footer>
                    </>
                )}
            </Modal>
        </>
    );
});

export default FormSelection;